import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/salary_scale/v1`;

export function getSalaryScaleByYear(year) {
   return axios({
      method: 'GET',
      headers: getHeaders(),
      url: `${url}/detail/${year}`
   });
}

export function getHistorySalaryScale(salaryScaleId) {
   return axios({
      method: 'GET',
      headers: getHeaders(),
      url: `${url}/histories/${salaryScaleId}`
   });
}

export function insertSalaryScale(data) {
   return axios({
      method: 'POST',
      headers: getHeaders(),
      url: `${url}/create`,
      data
   });
}

export function createAndUpdateSalaryScaleRow(data) {
   return axios({
      method: 'PUT',
      headers: getHeaders(),
      url: `${url}/create_or_update`,
      data
   });
}

export function deleteSalaryScaleRow(data) {
   return axios({
      method: 'PUT',
      headers: getHeaders(),
      url: `${url}/create_or_update`,
      data
   });
}

export function duplicateSalaryScaleRow(id, data) {
   return axios({
      method: 'POST',
      headers: getHeaders(),
      url: `${url}/duplicate/${id}`,
      data
   });
}